/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from 'react';
import { MenuItem } from "./MenuItem"
import { getUserInfo } from '../Login/Auth';
import { loginPageInfo, LoginPageInfo } from '../../config';

export function NavHeader({ item, Page, title }) {

  const [menuItems] = useState(item);
  const [page] = useState(Page);
  const [userInfo] = useState(getUserInfo())

  return (
    <li className="nav-header">
      <div className="dropdown profile-element">
        <span>
          <img alt="image" className="img-circle" src="/img/profile_small.jpg" />
        </span>

        <span className="clear">
          <span className="block m-t-xs">
            <strong className="font-bold">{userInfo.mobile}</strong>
          </span>
          <span className="text-muted text-xs block">{userInfo.nickName}</span>
          <span className="text-muted text-xs block">{userInfo.departmentName} - {userInfo.roleName}</span>
        </span>

      </div>
      <div className="logo-element">
        {
          loginPageInfo.getLogo()
        }
        </div>
    </li>
  )
}